import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import {ProjectsService} from 'src/app/shared/API-Service/services/projects.service'
import {OnlineDonationStateService} from 'src/app/shared/API-Service/services/online-donation-state.service'
import {RefCodeService} from 'src/app/shared/API-Service/services/RefCode.service'

@Component({
  selector: 'app-Online-Donations-Stats',
  templateUrl: './Online-Donations-Stats.component.html',
  styleUrls: ['./Online-Donations-Stats.component.css']
})
export class OnlineDonationsStatsComponent implements OnInit {
  projects:any
  OnlineDonationState: any;
  SearchForm = {
    fromDate: null,
    toDate: null,
    project: null,
    refCode: null,
  }
  RefCodes: any;
  constructor(private _FormBuilder:FormBuilder,private ProjectsService:ProjectsService,private OnlineDonationStateService:OnlineDonationStateService,private RefCodeService :RefCodeService) { }


  ngOnInit() {
    this.GetProjects()
    this.GetDonationHome()
    this.GetRefCodes()
    
  }
  GetProjects(){
    this.ProjectsService.GetProjects().subscribe(res=>{
      this.projects=res.data
    })
  }
  GetRefCodes(){
    this.RefCodeService.GetRefCodes().subscribe(res=>{
      this.RefCodes=res.data
    })
  }
  GetDonationHome(){
        this.OnlineDonationStateService.GetDonationHome(this.SearchForm).subscribe(res=>{
this.OnlineDonationState=res.data
console.log(this.OnlineDonationState)
    })
  }
  onSubmit(){
if(!this.SearchForm.fromDate){
  this.SearchForm.fromDate=null
}
 if(!this.SearchForm.toDate){
  this.SearchForm.toDate=null

 }
 console.log(this.SearchForm)
this.GetDonationHome()
  }
}
